<main>
  <p-confirmDialog />
  @if (isLoading()) {
    <loading-overlay [isLoading]="true"></loading-overlay>
  } @else if (finishingRoute()) {
    <header>
      <div>
        <div class="flex gap-[2rem]">
          <h1>{{ 'Finishing_Route_Detail_FinishingRoute' | translateWF: 'Finishing Route' }} - {{ finishingRoute()!.number }}</h1>
          @if (isAwaitingQA()) {
            <p-tag [value]="'Finishing_Route_Detail_AwaitingQA' | translateWF: 'Awaiting QA'" severity="warn" styleClass="ml-2" />
          }
          @if (isQAApproved()) {
            <p-tag [value]="'Finishing_Route_Detail_QAApproved' | translateWF: 'QA Approved'" severity="success" styleClass="ml-2" />
          }
        </div>
      </div>
      <div class="buttons">
        @if (showSendToRolling()) {
          <p-button [label]="'Finishing_Route_Detail_SendToRolling' | translateWF: 'Send to Rolling'" icon="pi pi-send" severity="success" (onClick)="onTransferToRolling()" />
        }
        @if (showReceiveFromFinishing()) {
          <p-button [label]="'Finishing_Route_Detail_Receive' | translateWF: 'Receive'" icon="pi pi-check" severity="info" (onClick)="onReceiveFinishingRoute()" />
        }
        <p-button [label]="'Finishing_Route_Detail_PrintReport' | translateWF: 'Print Report'" icon="pi pi-print" (onClick)="printFinishingRouteReport()" />
        @if (showTransferReport()) {
          <p-button [label]="'Finishing_Route_Detail_PrintTransferReport' | translateWF: 'Print Transfer Report'" icon="pi pi-file-pdf" (onClick)="printTransferReport()" />
        }
        <span class="separator"></span>
        <p-button [label]="'Finishing_Route_Detail_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
      </div>
    </header>

    <div class="content">
      @if (isAwaitingQA() && !isOnlyRollingProcessRemaining()) {
        <p-message severity="warn" styleClass="mb-3 p-2">
          {{
            'Finishing_Route_Detail_AllProcessesCompleted'
              | translateWF
                : 'All finishing processes are completed. This route
      is now Awaiting QA.'
          }}
        </p-message>
      }
      @if (hasRollingProcessPending() && !isOnlyRollingProcessRemaining() && !isAwaitingQA()) {
        <p-message severity="info" styleClass="mb-3 p-2">
          {{
            'Finishing_Route_Detail_RouteHasRollingPending'
              | translateWF
                : 'This route has a Rolling process pending. A transfer to Rolling will be required before the final
      process.'
          }}
        </p-message>
      }
      @if (showSendToRolling()) {
        <p-message severity="warn" styleClass="mb-3 p-2">
          {{ 'Finishing_Route_Detail_OnlyRollingRemains' | translateWF: "Only the Rolling process remains. Click 'Send to Rolling' to transfer this route for rolling." }}
        </p-message>
      }
      @if (showReceiveFromFinishing()) {
        <p-message severity="info" styleClass="mb-3 p-2">
          {{ getTransferInRouteMessage() }}
        </p-message>
      }
      @if (isLocationRolling()) {
        <p-message severity="success" styleClass="mb-3 p-2">
          {{ getLocationRollingMessage() }}
        </p-message>
      }
      <!-- Fabrics Section -->
      <p-panel [header]="'Finishing_Route_Detail_Fabrics' | translateWF: 'Fabrics'">
        <app-fabric-summary-table
          [viewMode]="'rolls'"
          [rolls]="rolls()"
          [fabrics]="fabrics"
          [productionCard]="productionCard"
          [bundles]="bundles"
          [showFabricsWithoutRolls]="false"
        />
      </p-panel>

      <!-- Processes Section -->
      <p-panel [header]="'Finishing_Route_Detail_Processes' | translateWF: 'Processes'">
        <ng-template pTemplate="icons">
          @if (canReorganizeFinishingRoute) {
            <p-button
              icon="pi pi-arrows-alt"
              [label]="'Finishing_Route_Detail_Reorganize' | translateWF: 'Reorganize'"
              severity="secondary"
              [outlined]="true"
              size="small"
              (onClick)="onReorganize()"
            />
          }
        </ng-template>

        <p-card data-variant="compact">
          @if (finishingRoute()!.route && finishingRoute()!.route.length > 0) {
            <!-- All Processes Table (Sorted: Completed → In Progress → Pending) -->
            <p-table [value]="allProcessesSorted()" [tableStyle]="{ 'min-width': '100%' }" styleClass="p-datatable-sm cs-datatable-editable cs-datatable-editable-highlight">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'Finishing_Route_Detail_Status' | translateWF: 'Status' }}</th>
                  <th>{{ 'Finishing_Route_Detail_ProcessID' | translateWF: 'Process ID' }}</th>
                  <th>{{ 'Finishing_Route_Detail_ProcessName' | translateWF: 'Process Name' }}</th>
                  <th>{{ 'Finishing_Route_Detail_StartTime' | translateWF: 'Start Time' }}</th>
                  <th>{{ 'Finishing_Route_Detail_EndTime' | translateWF: 'End Time' }}</th>
                  <th>{{ 'Finishing_Route_Detail_Duration' | translateWF: 'Duration' }}</th>
                  <th>{{ 'Finishing_Route_Detail_Station' | translateWF: 'Station' }}</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-process>
                @let processStrict = getProcessStrict(process);
                @let status = getProcessStatus(processStrict);
                <tr [ngClass]="{ 'editable-row': status === 'pending' }">
                  <td>
                    <p-tag [value]="getStatusLabel(status)" [severity]="status === 'completed' ? 'success' : status === 'in-progress' ? 'info' : 'warn'" />
                  </td>
                  <td>{{ processStrict.processId }}</td>
                  <td>{{ processStrict.processName | localized }}</td>
                  <td>{{ processStrict.startTime ? (processStrict.startTime | date: 'dd/MM/yy HH:mm:ss') : '---' }}</td>
                  <td>{{ processStrict.endTime ? (processStrict.endTime | date: 'dd/MM/yy HH:mm:ss') : '---' }}</td>
                  <td>
                    @if (status === 'completed') {
                      <span class="duration-badge">
                        <i class="pi pi-clock"></i>
                        {{ getProcessDuration(processStrict) }}
                      </span>
                    } @else if (status === 'in-progress') {
                      <span class="duration-badge warning">
                        <i class="pi pi-clock"></i>
                        {{ getProcessDuration(processStrict) }}
                      </span>
                    } @else {
                      ---
                    }
                  </td>
                  <td>{{ processStrict.endStationAssetId ? processStrict.endStationAssetId : processStrict.startStationAssetId }}</td>
                  <td>
                    @if (canEditFinishingRoute) {
                      <p-button icon="pi pi-cog" [rounded]="true" [text]="true" severity="secondary" size="small" (onClick)="openAdjustProcessModal(processStrict)" />
                    }
                  </td>
                </tr>
              </ng-template>
            </p-table>
          } @else {
            <p-message severity="info" [text]="'Finishing_Route_Detail_NoProcessSteps' | translateWF: 'No process steps defined for this finishing route.'" />
          }
        </p-card>
      </p-panel>

      <!-- Rolls Section -->
      <p-panel [header]="'Finishing_Route_Detail_Rolls' | translateWF: 'Rolls'">
        <ng-template pTemplate="icons">
          @if (canEditFinishingRoute) {
            <p-button
              icon="pi pi-plus"
              [label]="'Finishing_Route_Detail_AddSecondQualityRoll' | translateWF: 'Add Second Quality Roll'"
              severity="secondary"
              [outlined]="true"
              size="small"
              (onClick)="openSecondQualityRollModal()"
            />
          }
        </ng-template>
        <app-rolls-display-table [isReadOnly]="true" [rolls]="rolls()" [fabrics]="fabrics" [showFinalWeightIndicator]="true" />
      </p-panel>

      <!-- Notes Section -->
      <p-panel [header]="'Finishing_Route_Detail_Notes' | translateWF: 'Notes'">
        @if (userLite) {
          @if (canEditFinishingRoute) {
            <csl-standard-notes [userLite]="userLite" [notes]="notes()" (noteAdded)="onNoteAdded()" (viewMore)="onViewMoreNotes()" />
          } @else {
            <csl-standard-notes [notes]="notes()" [viewOnly]="true" (viewMore)="onViewMoreNotes()" />
          }
        }
      </p-panel>
    </div>
  } @else {
    <p-message severity="warn" [text]="'Finishing_Route_Detail_NoFinishingRouteData' | translateWF: 'No finishing route data found.'" />
  }
</main>
